module.exports = __webpack_public_path__ + "static/img/son5_active.d3ff3d81.png";